import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { PolicyComponentConfiguration } from "@idw-types/data/policy-component-configuration/policy-component-configuration";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequest } from "@utils/http-util";

type GetDeployedPolicyComponentsRequestResponse = {
    deployedPolicyComponents: Array<PolicyComponentConfiguration>;
};

export const getDeployedPolicyComponentsRequest = async (): Promise<GenericNetworkResponse<GetDeployedPolicyComponentsRequestResponse>> => {
    const route = apiRoutes.serviceConfiguration.deployedPolicyComponents;


    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};